import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHiking } from "@fortawesome/free-solid-svg-icons";
import PlanItemBase from "./PlanItemBase";
import ItemDescription from "./ItemDescription";

const TrekkingItem = ({ item }) => {
  const time = new Date(item.startDate).toLocaleTimeString("pl-PL", {
    hour: "2-digit",
    minute: "2-digit",
  });

  const formatDuration = (duration) => {
    const [hours, minutes] = duration.split(":").map(Number);
    return `${hours}h ${minutes}min`;
  };

  return (
    <PlanItemBase
      icon={<FontAwesomeIcon icon={faHiking} className="plan-icon" />}
      time={time}
      name={item.name}
    >
      <div className="item-details">
      {item.distance && (
        <p>
          <strong>Dystans:</strong> {item.distance} km
        </p>
      )}
      {item.duration && (
        <p>
          <strong>Czas:</strong> {formatDuration(item.duration)} 
        </p>
      )}
      {item.elevation && (
        <p>
          <strong>Przewyższenie:</strong> {item.elevation} m
        </p>
      )}

      {item.difficultyLevel && (
        <p>
          <strong>Trudność:</strong> {item.difficultyLevel}
        </p>
      )}
        {item.link && (
          <p>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              Przebieg trasy
            </a>
          </p>
        )}
                {item.description && (
                  <ItemDescription description={item.description} />
        )}
      </div>
    </PlanItemBase>
  );
};

export default TrekkingItem;
